import { Alert, Button, TextField } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Patient } from '../../../../domain/entities';
import { usePatientService } from '../../../hooks';
import { appointmentActions } from '../../../store/appointment';
import { ErrorObject } from '../../../types/types';
import { Validator } from '../../../../utils/validator';

interface Props {
  onPatientSelected: (patient: Patient | undefined) => void;
}

const SSNPatientInputField = ({ onPatientSelected }: Props) => {
  const PatientService = usePatientService();
  const dispatch = useDispatch();

  const [searchSSN, setSearchSSN] = useState('');
  const [errorSearchSSN, setErrorSearchSSN] = useState<ErrorObject>();

  const [patientNotFound, setPatientNotFound] = useState<boolean>(false);

  const isValid = () => {
    const errorData = Validator(searchSSN, ['required', 'length'], {
      length: 10
    });
    setErrorSearchSSN(errorData);
    return !errorData.hasError;
  };

  const searchPatient = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!isValid()) return;

    const searchedPatient = await PatientService.findOneBySSN(searchSSN);
    onPatientSelected(searchedPatient);
    if (!searchedPatient) {
      setPatientNotFound(true);
      return;
    }

    dispatch(
      appointmentActions.setClient({
        id: searchedPatient.id,
        name: searchedPatient.name
      })
    );
    setPatientNotFound(false);
  };

  return (
    <form onSubmit={searchPatient}>
      <TextField
        id='ssnPatient'
        label='Buscar por cédula'
        value={searchSSN}
        onChange={(event) => setSearchSSN(event.target.value)}
        autoComplete='off'
        InputProps={{
          endAdornment: (
            <Button type='submit' variant='contained' color='primary'>
              Buscar
            </Button>
          )
        }}
        error={errorSearchSSN?.hasError}
        helperText={errorSearchSSN?.message}
      />
      {patientNotFound && (
        <Alert sx={{ marginTop: 3 }} severity='warning'>
          No se ha encontrado un paciente con esta información
        </Alert>
      )}
    </form>
  );
};

export default SSNPatientInputField;
